module.exports = __webpack_public_path__ + "img/answerTrue.fd544b12.png";